import { Brain, Lightbulb, Camera, Package, Wand2, TrendingUp } from "lucide-react";

const iconMap = {
  Brain,
  Lightbulb,
  Camera,
  Package,
  Wand2,
  TrendingUp,
};

const modules = [
  { id: "1", number: "01", title: "Fundamentos de IA Generativa", description: "Entenda os principios por tras da geracao de imagens com IA, modelos de difusao e como otimizar prompts para resultados profissionais.", icon: "Brain" },
  { id: "2", number: "02", title: "Iluminacao Virtual de Estudio", description: "Domine tecnicas de iluminacao Rembrandt, butterfly e split usando descritores de IA para replicar setups profissionais.", icon: "Lightbulb" },
  { id: "3", number: "03", title: "Retrato e Moda com IA", description: "Crie retratos e fotos de moda com qualidade editorial, dominando poses, expressoes e estilos visuais unicos.", icon: "Camera" },
  { id: "4", number: "04", title: "Fotografia de Produto", description: "Aprenda a gerar imagens de produtos com acabamento comercial, fundos limpos e composicoes que vendem.", icon: "Package" },
  { id: "5", number: "05", title: "Pos-Producao Avancada", description: "Tecnicas de refinamento, upscaling, correcao de cor e ajustes finais para resultados impecaveis.", icon: "Wand2" },
  { id: "6", number: "06", title: "Portfolio e Monetizacao", description: "Construa seu portfolio profissional e aprenda estrategias para monetizar suas habilidades no mercado.", icon: "TrendingUp" },
];

export default function Curriculum() {

  return (
    <section
      id="curriculum"
      data-testid="curriculum-section"
      className="py-24 md:py-32 lg:py-40 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-16 md:mb-20">
          <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[#00FF00] mb-4">
            // Ementa completa
          </p>
          <h2 className="font-['Outfit'] text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-white">
            O que voce vai <span className="text-[#00FF00]">dominar</span>
          </h2>
          <p className="text-base md:text-lg text-white/50 mt-4 max-w-xl">
            6 modulos estrategicamente desenhados para levar voce do zero ao profissional.
          </p>
        </div>

        {/* Modules grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border border-white/5">
          {modules.map((mod, index) => {
            const Icon = iconMap[mod.icon] || Brain;
            return (
              <div
                key={mod.id}
                data-testid={`curriculum-module-${mod.id}`}
                className="module-card p-8 md:p-10 border border-white/5 bg-[#0A0A0A] group"
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="font-['JetBrains_Mono'] text-xs text-white/20 tracking-wider">
                    {mod.number}
                  </span>
                  <Icon
                    size={20}
                    className="text-[#00FF00]/60 group-hover:text-[#00FF00] transition-colors duration-500"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="font-['Outfit'] text-xl md:text-2xl font-medium tracking-tight text-white mb-4 group-hover:text-[#00FF00] transition-colors duration-500">
                  {mod.title}
                </h3>
                <p className="text-sm text-white/40 leading-relaxed group-hover:text-white/60 transition-colors duration-500">
                  {mod.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
